"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("models").service("UsersService", ["$rootScope", "ApiService", "READ_SUMMARY_URL", "DEPA_FORM_URL", "EmailHistoryService", "DamagesService", "CoursesService", "ElearningTemplatesService", "ElearningCampaignsService", "DepasService", "LalsService", "VehiclesService", "ModalService", "CustomListsService", "ActionHistoriesService", function ($rootScope, ApiService, READ_SUMMARY_URL, DEPA_FORM_URL, EmailHistoryService, DamagesService, CoursesService, ElearningTemplatesService, ElearningCampaignsService, DepasService, LalsService, VehiclesService, ModalService, CustomListsService, ActionHistoriesService) {
  var _this2 = this;

  var that = this;

  var params = {
    name: "users",
    attributesForCache: ["lastName", // Tous les attributs sont à mettre ici pour que la fiche récap. fonctionne
    "firstName", "internalNumber", "_id", "customerId", "trueInternalNumber", "email", "cellularPhone", "phone", "defaultManagerId", "rhManagerId", "qseManagerId", "fleetManagerId", "other1ManagerId", "other2ManagerId", "defaultManagerIdIsAutoFilled", "rhManagerIdIsAutoFilled", "qseManagerIdIsAutoFilled", "fleetManagerIdIsAutoFilled", "other1ManagerIdIsAutoFilled", "other2ManagerIdIsAutoFilled", "groupsId", "usersEmailsCcId", "typeVehicles", "contract", "yearOfBirth", "startDate", "endDate", "endBlockDate", "creationDate", "lastUserModificationDate", "importDate", "importBy", "updateDate", "updateBy", "active", "positions", "positionTitle", "areaName", "departmentName", "licenceValidityDate", "role", "rights", "onlyMerchandise", "canLoginToBeta", "isVirtual", "isVisibleByEveryone", "toCheck", "externalCompany", "nbDamages", "nbAccidents", "nbMissingDepas", "nbDepas", "nbCourses", "lastDamageDate", "lastDepaDate", "lastCourseDate", "nbDispute0", "nbDispute50", "nbDispute100", "note", "creationUserId", "isServiceAccount"],

    formatName: function formatName(element) {
      return element ? that.getName(element) : "???";
    }
    //defaultOrder: {date: -1},
  };

  angular.extend(that, ApiService.getModelBis(params));

  that.displayInfo = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(user) {
      var isAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isLvr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var isSuperAdmin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var syncConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var _this = this;

      var telematicSyncConfig = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var softwareName = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

      var token, source, from, to, filter, emails, appShortUrl, json, userLinkData, userData, shortLinks, longLinks, challengeLinks, damages, courses, templates, typeOfAccidentList, reasonCancelList, campaigns, accidentOriginList, _ref2, _ref3, campaignLinks, elearningLinks, challenges, doneVideosNumber, doneElearningsNumber, doneChallengeNumber, allChallengesNumber, challengeNames, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop4, _iterator, _step, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop5, _iterator2, _step2, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _loop6, _iterator3, _step3, _ret6, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _challenge2, allDone, doneLinks, depas, depasDoneNumber, lals, depaIds, lalIds, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _loop, _iterator5, _step5, indexLal, lal, damage, indexDepa, depa, date, dateString, depaReport, _date, _dateString, managerAct, reasonCancelData, indexCourse, course, forms, longMonths, shortMonths, i, _date2, telematicFields, elearningHistoryLines, campaignHistoryLines, challengeHistoryLines, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, link, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _link, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, challenge, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _link2, damageLines, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _loop2, _iterator10, _step10, lvrComments, accidentOrigins, _depas, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _loop3, _iterator11, _step11, actionHistoryfrom, actionHistoryTo, where, actionHistories;

      return regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

              _context3.next = 3;
              return ApiService.getToken();

            case 3:
              token = _context3.sent;
              source = READ_SUMMARY_URL + "/";
              from = moment().subtract(3, "month").toDate();
              to = moment().toDate();
              filter = [];

              if (user.email) {
                filter = [{ to: user.email }, { cc: user.email }, { bcc: user.email }, { to: { $regex: user.email } }, { cc: { $regex: user.email } }, { bcc: { $regex: user.email } }];
              }
              if (user.cellularPhone) {
                filter.push({ phone: user.cellularPhone });
              }

              user.depaDocs = [];

              if (!(user.email && filter.length && (isAdmin == true || isLvr == true))) {
                _context3.next = 17;
                break;
              }

              _context3.next = 14;
              return EmailHistoryService.find({
                filter: {
                  where: {
                    creationDate: { $gte: from, $lte: to },
                    $or: filter
                  },
                  fields: ["_id", "customerId", "from", "to", "cc", "bcc", "creationDate", "subject", "readDate", "status", "reports", "report", "phone", "smsStatus", "smsText", "triggeredBy", "error", "html"],
                  order: { creationDate: -1 }
                }
              });

            case 14:
              _context3.t0 = _context3.sent;
              _context3.next = 18;
              break;

            case 17:
              _context3.t0 = [];

            case 18:
              emails = _context3.t0;
              appShortUrl = "";
              _context3.prev = 20;
              _context3.next = 23;
              return that.customGet("token/" + user._id);

            case 23:
              json = _context3.sent;

              appShortUrl = json.shortUrl;
              _context3.next = 30;
              break;

            case 27:
              _context3.prev = 27;
              _context3.t1 = _context3["catch"](20);

              Notiflix.Notify.failure("Échec de la récupération du token utilisateur.");

            case 30:
              _context3.next = 32;
              return that.find({
                filter: {
                  where: { _id: user._id },
                  fields: { shortLinks: true, longLinks: true, challengeLinks: true }
                }
              });

            case 32:
              userLinkData = _context3.sent;
              userData = userLinkData && userLinkData[0] || {};
              shortLinks = (userData.shortLinks || []).slice().sort(function (a, b) {
                return new Date(b.startDate) - new Date(a.startDate);
              });
              longLinks = (userData.longLinks || []).slice().sort(function (a, b) {
                return new Date(b.startDate) - new Date(a.startDate);
              });
              challengeLinks = userData.challengeLinks || [];
              damages = void 0;
              courses = void 0;
              templates = void 0;
              typeOfAccidentList = void 0;
              reasonCancelList = void 0;
              campaigns = void 0;
              accidentOriginList = void 0;
              _context3.t2 = Promise;
              _context3.t3 = DamagesService.find({
                filter: {
                  where: { driverId: "$" + user._id },
                  order: { dateDamage: 1 }
                }
              });
              _context3.t4 = CoursesService.find({
                filter: {
                  where: { traineesId: "$" + user._id },
                  order: { creationDate: 1 }
                }
              });
              _context3.t5 = ElearningTemplatesService.find({
                filter: {
                  order: { creationDate: 1 },
                  fields: {
                    _id: true,
                    name: true,
                    type: true,
                    vehicleType: true,
                    quizz: true,
                    challengeName: true,
                    challengeDay: true
                  }
                }
              });
              _context3.t6 = CustomListsService.getSelectArray("typeOfAccidentV2");
              _context3.t7 = CustomListsService.getSelectArray("reasonDepaCancelled");
              _context3.t8 = ElearningCampaignsService.find({
                filter: {
                  where: { customerId: $rootScope.$selectedCustomerId },
                  order: { creationDate: 1 },
                  fields: {
                    _id: true,
                    name: true,
                    type: true,
                    usersId: true,
                    startDate: true,
                    lastGenerationDate: true,
                    challengeIncrement: true
                  }
                }
              });
              _context3.next = 53;
              return CustomListsService.getSelectArray("accidentOrigin");

            case 53:
              _context3.t9 = _context3.sent;
              _context3.t10 = [_context3.t3, _context3.t4, _context3.t5, _context3.t6, _context3.t7, _context3.t8, _context3.t9];
              _context3.next = 57;
              return _context3.t2.all.call(_context3.t2, _context3.t10);

            case 57:
              _ref2 = _context3.sent;
              _ref3 = _slicedToArray(_ref2, 7);
              damages = _ref3[0];
              courses = _ref3[1];
              templates = _ref3[2];
              typeOfAccidentList = _ref3[3];
              reasonCancelList = _ref3[4];
              campaigns = _ref3[5];
              accidentOriginList = _ref3[6];
              campaignLinks = [];
              elearningLinks = [];
              challenges = [];
              doneVideosNumber = 0;
              doneElearningsNumber = 0;
              doneChallengeNumber = 0;
              allChallengesNumber = 0;
              challengeNames = [];

              // Short links (filtering already done by convertDoneElearningToCourse)

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context3.prev = 77;

              _loop4 = function _loop4() {
                var link = _step.value;

                var template = templates.find(function (t) {
                  return t._id == link.elearningTemplateId;
                });
                link.type = "short";
                link.name = template ? template.name : "???";
                if (template && (!template.quizz || !template.quizz.length)) {
                  link.score = "Pas de quiz";
                }
                if (link.progress >= 95 || link.viewed) {
                  link.viewed = true;
                  doneVideosNumber += 1;
                }
                campaignLinks.push(link);
              };

              for (_iterator = shortLinks[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop4();
              }

              // Long links (filtering already done by convertDoneElearningToCourse)
              _context3.next = 86;
              break;

            case 82:
              _context3.prev = 82;
              _context3.t11 = _context3["catch"](77);
              _didIteratorError = true;
              _iteratorError = _context3.t11;

            case 86:
              _context3.prev = 86;
              _context3.prev = 87;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 89:
              _context3.prev = 89;

              if (!_didIteratorError) {
                _context3.next = 92;
                break;
              }

              throw _iteratorError;

            case 92:
              return _context3.finish(89);

            case 93:
              return _context3.finish(86);

            case 94:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context3.prev = 97;

              _loop5 = function _loop5() {
                var link = _step2.value;

                var template = templates.find(function (t) {
                  return t._id == link.elearningTemplateId;
                });
                link.type = "long";
                link.name = template ? template.name : "???";
                if (template && (!template.quizz || !template.quizz.length)) {
                  link.score = "Pas de quiz";
                }
                if (link.emailReminderDate1) user.lastAutoReminder = link.emailReminderDate1;
                if (link.emailReminderDate2) user.lastAutoReminder = link.emailReminderDate2;
                if (link.emailReminderDate3) user.lastAutoReminder = link.emailReminderDate3;
                if (link.progress >= 95 || link.viewed) {
                  link.viewed = true;
                  doneElearningsNumber += 1;
                }
                elearningLinks.push(link);
              };

              for (_iterator2 = longLinks[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop5();
              }

              // Challenge links (still need campaigns for challengeIncrement)
              _context3.next = 106;
              break;

            case 102:
              _context3.prev = 102;
              _context3.t12 = _context3["catch"](97);
              _didIteratorError2 = true;
              _iteratorError2 = _context3.t12;

            case 106:
              _context3.prev = 106;
              _context3.prev = 107;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 109:
              _context3.prev = 109;

              if (!_didIteratorError2) {
                _context3.next = 112;
                break;
              }

              throw _iteratorError2;

            case 112:
              return _context3.finish(109);

            case 113:
              return _context3.finish(106);

            case 114:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context3.prev = 117;

              _loop6 = function _loop6() {
                var link = _step3.value;

                var template = templates.find(function (t) {
                  return t._id == link.elearningTemplateId;
                });
                if (!template || !template.challengeName) return "continue";
                var campaign = link.elearningCampaignId ? campaigns.find(function (c) {
                  return c._id == link.elearningCampaignId;
                }) : null;
                // Un challenge peut venir d'une formation (courseId sans elearningCampaignId) :
                // dans ce cas startDate est déjà la date exacte, pas d'incrément à ajouter.
                var challengeIncrement = campaign ? campaign.challengeIncrement || 2 : 0;
                link.type = "challenge";
                link.name = template.name || "???";
                if (!challengeNames.includes(template.challengeName)) {
                  challengeNames.push(template.challengeName);
                  allChallengesNumber += 1;
                  link.challengeDay = template.challengeDay;
                  link.increment = challengeIncrement * (template.challengeDay - 1);
                  challenges.push({ name: template.challengeName, links: [link] });
                } else {
                  var _challenge = challenges.find(function (c) {
                    return c.name === template.challengeName;
                  });
                  if (_challenge) {
                    link.challengeDay = template.challengeDay;
                    link.increment = challengeIncrement * (template.challengeDay - 1);
                    _challenge.links.push(link);
                  }
                }
                if (link.progress >= 95 || link.viewed) {
                  link.viewed = true;
                }
              };

              _iterator3 = challengeLinks[Symbol.iterator]();

            case 120:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context3.next = 127;
                break;
              }

              _ret6 = _loop6();

              if (!(_ret6 === "continue")) {
                _context3.next = 124;
                break;
              }

              return _context3.abrupt("continue", 124);

            case 124:
              _iteratorNormalCompletion3 = true;
              _context3.next = 120;
              break;

            case 127:
              _context3.next = 133;
              break;

            case 129:
              _context3.prev = 129;
              _context3.t13 = _context3["catch"](117);
              _didIteratorError3 = true;
              _iteratorError3 = _context3.t13;

            case 133:
              _context3.prev = 133;
              _context3.prev = 134;

              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }

            case 136:
              _context3.prev = 136;

              if (!_didIteratorError3) {
                _context3.next = 139;
                break;
              }

              throw _iteratorError3;

            case 139:
              return _context3.finish(136);

            case 140:
              return _context3.finish(133);

            case 141:
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context3.prev = 144;


              for (_iterator4 = challenges[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                _challenge2 = _step4.value;
                allDone = false;

                if (_challenge2.links && _challenge2.links.length > 0) {
                  doneLinks = _challenge2.links.filter(function (link) {
                    return link.viewed;
                  });

                  if (doneLinks.length === _challenge2.links.length) {
                    allDone = true;
                  }
                }
                _challenge2.links = _challenge2.links.sort(function (a, b) {
                  return a.challengeDay - b.challengeDay;
                });
                if (allDone) {
                  doneChallengeNumber += 1;
                }
              }

              _context3.next = 152;
              break;

            case 148:
              _context3.prev = 148;
              _context3.t14 = _context3["catch"](144);
              _didIteratorError4 = true;
              _iteratorError4 = _context3.t14;

            case 152:
              _context3.prev = 152;
              _context3.prev = 153;

              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }

            case 155:
              _context3.prev = 155;

              if (!_didIteratorError4) {
                _context3.next = 158;
                break;
              }

              throw _iteratorError4;

            case 158:
              return _context3.finish(155);

            case 159:
              return _context3.finish(152);

            case 160:
              depas = [];
              depasDoneNumber = 0;
              lals = [];

              if (!(damages && damages.length > 0)) {
                _context3.next = 194;
                break;
              }

              depaIds = [];
              lalIds = [];
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context3.prev = 169;

              _loop = function _loop() {
                var damage = _step5.value;

                var typeOfAccidentData = typeOfAccidentList.find(function (item) {
                  return damage.typeOfAccident === item.value;
                });
                if (typeOfAccidentData) {
                  damage.typeOfAccidentName = typeOfAccidentData.name.split(" (")[0];
                } else {
                  damage.typeOfAccidentName = "N.C.";
                }

                if (damage.depaId && damage.depaId.length >= 24) {
                  depaIds = [].concat(_toConsumableArray(depaIds), [damage.depaId.replace("$", "")]);
                }
                if (damage.lalIds && damage.lalIds.length > 0) {
                  lalIds = [].concat(_toConsumableArray(lalIds), _toConsumableArray(damage.lalIds));
                }
                damage.pourcentageDispute = typeof damage.pourcentageDispute !== "undefined" && damage.pourcentageDispute !== null && ["0", "50", "100"].includes(damage.pourcentageDispute.toString()) ? damage.pourcentageDispute + " %" : "";
              };

              for (_iterator5 = damages[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                _loop();
              }
              _context3.next = 178;
              break;

            case 174:
              _context3.prev = 174;
              _context3.t15 = _context3["catch"](169);
              _didIteratorError5 = true;
              _iteratorError5 = _context3.t15;

            case 178:
              _context3.prev = 178;
              _context3.prev = 179;

              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }

            case 181:
              _context3.prev = 181;

              if (!_didIteratorError5) {
                _context3.next = 184;
                break;
              }

              throw _iteratorError5;

            case 184:
              return _context3.finish(181);

            case 185:
              return _context3.finish(178);

            case 186:
              if (!(depaIds.length > 0)) {
                _context3.next = 190;
                break;
              }

              _context3.next = 189;
              return DepasService.find({
                filter: {
                  where: { _id: { $in: depaIds } }
                }
              });

            case 189:
              depas = _context3.sent;

            case 190:
              if (!(lalIds.length > 0)) {
                _context3.next = 194;
                break;
              }

              _context3.next = 193;
              return LalsService.find({
                filter: {
                  where: { _id: { $in: lalIds } },
                  fields: {
                    _id: true,
                    pourcentageDispute: true,
                    statusInsurer: true,
                    costTotal: true
                  }
                }
              });

            case 193:
              lals = _context3.sent;

            case 194:

              if (lals && lals.length > 0) {
                for (indexLal = 0; indexLal < lals.length; indexLal++) {
                  lal = lals[indexLal];
                  damage = damages.find(function (damage) {
                    return damage.lalIds && damage.lalIds.includes(lal._id);
                  });
                  // TODO: calculate cost here !

                  if (damage) {
                    damage.lal = lal;
                    if (damage.lal.costTotal) {
                      damage.lal.costTotal = Math.round(damage.lal.costTotal * 100) / 100;
                    }
                  }
                }
              }

              if (depas && depas.length > 0) {
                for (indexDepa = 0; indexDepa < depas.length; indexDepa++) {
                  depa = depas[indexDepa];
                  damage = damages.find(function (damage) {
                    return damage.depaId === "$" + depa._id;
                  });


                  if (depa.status === "Effectué") {
                    depasDoneNumber += 1;

                    if (depa.answers && depa.answers.commentDetails) {
                      damage.circumstance = depa.answers.commentDetails;
                    }

                    if (depa.answers && depa.answers.keywords && depa.answers.keywords.length > 0) {
                      depa.keywords = depa.answers.keywords.map(function (keyword) {
                        return "#" + keyword;
                      }).join(", ");
                    }

                    if (depa.answers && depa.answers.dateDamage && depa.answers.firstName && depa.answers.lastName && depa.docs && depa.docs.length > 0 && depa.docs[depa.docs.length - 1].what && depa.docs[depa.docs.length - 1].what.name === "Fiche Entretien") {
                      date = new Date(depa.answers.dateDamage);
                      dateString = date.toLocaleDateString();
                      depaReport = depa.docs[depa.docs.length - 1];

                      depaReport.what.name += " - Sinistre du " + dateString;

                      user.depaDocs.push(depaReport);
                    }
                  }
                  if (depa.managerAct && depa.managerAct.docs && depa.managerAct.docs.length > 0) {
                    _date = new Date(depa.answers.dateDamage);
                    _dateString = _date.toLocaleDateString();
                    managerAct = depa.managerAct.docs[depa.managerAct.docs.length - 1];

                    managerAct.name = "Acte manag\xE9rial - Sinistre du " + _dateString;

                    user.depaDocs.push(managerAct);
                  }

                  if (depa.status === "Annulé") {
                    reasonCancelData = reasonCancelList.find(function (item) {
                      return depa.reasonCancel === item.value;
                    });

                    if (reasonCancelData) {
                      depa.reasonCancelName = reasonCancelData.name;
                    } else {
                      depa.reasonCancelName = "Raison indéterminée";
                    }
                  }

                  damage.depa = depa;
                }
              }

              indexCourse = 0;

            case 197:
              if (!(indexCourse < courses.length)) {
                _context3.next = 213;
                break;
              }

              course = courses[indexCourse];

              if (!course.duration) {
                _context3.next = 205;
                break;
              }

              _context3.next = 202;
              return CustomListsService.getNameByValue("courseDuration", course.duration);

            case 202:
              course.durationName = _context3.sent;
              _context3.next = 206;
              break;

            case 205:
              course.durationName = "N.C.";

            case 206:
              if (!course.type) {
                _context3.next = 210;
                break;
              }

              _context3.next = 209;
              return CustomListsService.getNameByValue("courseType", course.type);

            case 209:
              course.typeName = _context3.sent;

            case 210:
              indexCourse++;
              _context3.next = 197;
              break;

            case 213:

              depas.reverse();
              damages.reverse();
              courses.reverse();

              Notiflix.Loading.remove();

              forms = [{
                name: "Généralités",
                filters: ["Fiche", "Fiche avec sinistres détaillés"],
                lines: [{
                  label: "Nom",
                  value: user.lastName,
                  titleBefore: "Identification"
                }, {
                  label: "Prénom",
                  value: user.firstName
                }, {
                  label: "ID " + (syncConfig ? syncConfig.software : ""),
                  value: user.internalNumber,
                  hidden: !syncConfig || !syncConfig.software
                }, {
                  label: "Matricule",
                  value: syncConfig && syncConfig.software ? user.trueInternalNumber : user.internalNumber
                }, {
                  label: "Titre",
                  value: user.positionTitle
                }, {
                  label: "Commentaires",
                  value: user.note
                }, {
                  label: "Email",
                  value: user.email,
                  titleBefore: "Contact"
                }, {
                  label: "Portable",
                  value: user.cellularPhone
                }, {
                  label: "Téléphone fixe",
                  value: user.phone
                }, {
                  label: "Fonctions",
                  value: user.positions ? user.positions.join(", ") : "",
                  titleBefore: "Affectation"
                }, {
                  label: "Contrat",
                  value: user.contractName
                }, {
                  label: "Société d'intérim",
                  value: user.externalCompany
                }, {
                  label: "Types de véhicules conduits",
                  value: user.typeVehicleNames ? user.typeVehicleNames.join(", ") : ""
                }, {
                  label: "Véhicules affectés",
                  value: user.vehicleNames
                }, {
                  label: "Zone de travail",
                  value: user.areaName
                }, {
                  label: "Département",
                  value: user.departmentName
                }, {
                  label: "Groupes associés",
                  value: user.groupName
                }, {
                  label: $rootScope.defaultManagerLabel,
                  value: user.managerNameWithEmail,
                  titleBefore: "Responsables"
                }, {
                  label: $rootScope.rhManagerLabel,
                  value: user.rhManagerNameWithEmail,
                  hidden: $rootScope.rhManagerHidden
                }, {
                  label: $rootScope.qseManagerLabel,
                  value: user.qseManagerNameWithEmail,
                  hidden: $rootScope.qseManagerHidden
                }, {
                  label: $rootScope.fleetManagerLabel,
                  value: user.fleetManagerNameWithEmail,
                  hidden: $rootScope.fleetManagerHidden
                }, {
                  label: $rootScope.other1ManagerLabel,
                  value: user.other1ManagerNameWithEmail,
                  hidden: $rootScope.other1ManagerHidden
                }, {
                  label: $rootScope.other2ManagerLabel,
                  value: user.other2ManagerNameWithEmail,
                  hidden: $rootScope.other2ManagerHidden
                }, {
                  label: "Personnes en copie des emails de déclaration de sinistre",
                  value: user.usersEmailCc
                }, {
                  label: "Année de naissance",
                  value: user.yearOfBirth,
                  titleBefore: "Dates"
                }, {
                  label: "Date validité permis",
                  value: user.licenceValidityDate ? moment(user.licenceValidityDate).format("DD/MM/YYYY") : ""
                }, {
                  label: "Date d'embauche",
                  value: user.startDate ? moment(user.startDate).format("DD/MM/YYYY") : ""
                }, {
                  label: "Date de sortie",
                  value: user.endDate ? moment(user.endDate).format("DD/MM/YYYY") : ""
                }, {
                  label: "Date fin d'arrêt (congé, maladie, etc.)",
                  value: user.endBlockDate ? moment(user.endBlockDate).format("DD/MM/YYYY") : ""
                }]
              }];
              longMonths = [];
              shortMonths = [];

              for (i = 0; i < 4; i++) {
                _date2 = moment().subtract(i, "month");

                longMonths.unshift(_date2.format("MMMM YY"));
                shortMonths.unshift(_date2.format("-YY-MM"));
              }
              longMonths.unshift("");

              if (telematicSyncConfig && telematicSyncConfig.software && user.withTelematic) {
                telematicFields = telematicSyncConfig.fields;


                forms.push({
                  name: softwareName,
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  isMultiColumns: true,
                  headers: longMonths,
                  lines: [{
                    label: telematicSyncConfig.software === "WEBFLEET" ? "Note de conduite générale" : telematicSyncConfig.software === "ADDSECURE" ? "Note générale d'éco-conduite" : "???",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["globalScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("globalScore")
                  }, {
                    label: telematicSyncConfig.software === "WEBFLEET" ? "Note Utilisation de l'inertie" : telematicSyncConfig.software === "ADDSECURE" ? "Note Inertie" : "???",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["coastingScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("coastingScore")
                  }, {
                    label: "Note Consommation",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["fuelUsageScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("fuelUsageScore")
                  }, {
                    label: telematicSyncConfig.software === "WEBFLEET" ? "Note Arrêt moteur tournant" : telematicSyncConfig.software === "ADDSECURE" ? "Note Ralenti" : "???",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["idlingScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("idlingScore")
                  }, {
                    label: "Note Évènement de conduite",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["drivingEventsScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("drivingEventsScore")
                  }, {
                    label: "Note Vitesse constante",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["constantSpeedScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("constantSpeedScore")
                  }, {
                    label: "Note Vitesse écologique",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["greenSpeedScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("greenSpeedScore")
                  }, {
                    label: "Note Surrégime",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["highRevvingScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("highRevvingScore")
                  }, {
                    label: "Note Survitesse",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["overSpeedScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("overSpeedScore")
                  }, {
                    label: "Note Inertie en décélération",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["rolloutScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("rolloutScore")
                  }, {
                    label: "Note Énergie gaspillée",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["wastedEnergyScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("wastedEnergyScore")
                  }, {
                    label: "Note Freinage brusque",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["harshBrakingScoreTelematic" + month],
                        withBar: true
                      };
                    }),
                    hidden: !telematicFields.includes("harshBrakingScore")
                  }, {
                    label: "Distance parcourue",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: Math.round(user["distanceTotalTelematic" + month]),
                        unit: "km"
                      };
                    }),
                    hidden: !telematicFields.includes("distanceTotal")
                  }, {
                    label: "Consommation de carburant mensuelle",
                    columns: shortMonths.map(function (month) {
                      return {
                        value: user["fuelUsagePer100KmTelematic" + month],
                        unit: "L/100km"
                      };
                    }),
                    hidden: !telematicFields.includes("fuelUsage")
                  }]
                });
              }

              elearningHistoryLines = [];
              campaignHistoryLines = [];
              challengeHistoryLines = [];

              if (!(elearningLinks && elearningLinks.length > 0)) {
                _context3.next = 248;
                break;
              }

              if (user.lastAutoReminder) {
                elearningHistoryLines.push({
                  label: "Dernière relance automatique",
                  columns: [{
                    value: moment(user.lastAutoReminder).format("DD/MM/YYYY")
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }]
                });
              }
              if (user.longElearninglastEmailSentDate) {
                elearningHistoryLines.push({
                  label: "Dernière relance manuelle (ou suite à un DEPA)",
                  columns: [{
                    value: moment(user.longElearninglastEmailSentDate).format("DD/MM/YYYY")
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }]
                });
              } else if (user.longElearninglastSmsSentDate) {
                elearningHistoryLines.push({
                  label: "Dernière relance manuelle (ou suite à un DEPA)",
                  columns: [{
                    value: moment(user.longElearninglastSmsSentDate).format("DD/MM/YYYY")
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }]
                });
              }
              _iteratorNormalCompletion6 = true;
              _didIteratorError6 = false;
              _iteratorError6 = undefined;
              _context3.prev = 232;
              for (_iterator6 = elearningLinks[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                link = _step6.value;

                elearningHistoryLines.push({
                  label: link.name,
                  color: link.viewed || link.progress >= 95 ? "#337ab7" : link.emailSentDate && !link.emailErrorcode || link.smsSentDate ? "#F9A159" : "#ff3108",
                  columns: [{
                    value: link.emailSentDate && !link.emailErrorcode ? moment(link.emailSentDate).add(link.increment || 0, "days").format("DD/MM/YYYY") + " (par email)" : link.smsSentDate ? moment(link.smsSentDate).add(link.increment || 0, "days").format("DD/MM/YYYY") + " (par SMS)" : moment(link.startDate).add(link.increment || 0, "days").format("DD/MM/YYYY") + (link.emailErrorcode ? " (non délivrée)" : link.isWithQrCode ? " (QR code)" : link.viewed || link.progress >= 95 ? "" : " (non envoyée)")
                  }, {
                    value: link.viewed || link.progress >= 95 ? "Oui" : "Non"
                  }, {
                    value: link.doneDate ? moment(link.doneDate).format("DD/MM/YYYY") : ""
                  }, {
                    value: link.total ? link.score + "/" + link.total : !link.viewed ? "" : link.score !== "Pas de quiz" ? link.courseId && !link._id ? "Visualisé lors d'une session de formation" : "Non répondu" : "Sans quiz"
                  }]
                });
              }
              _context3.next = 240;
              break;

            case 236:
              _context3.prev = 236;
              _context3.t16 = _context3["catch"](232);
              _didIteratorError6 = true;
              _iteratorError6 = _context3.t16;

            case 240:
              _context3.prev = 240;
              _context3.prev = 241;

              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }

            case 243:
              _context3.prev = 243;

              if (!_didIteratorError6) {
                _context3.next = 246;
                break;
              }

              throw _iteratorError6;

            case 246:
              return _context3.finish(243);

            case 247:
              return _context3.finish(240);

            case 248:
              if (!(campaignLinks && campaignLinks.length > 0)) {
                _context3.next = 269;
                break;
              }

              if (user.shortElearninglastEmailSentDate) {
                campaignHistoryLines.push({
                  label: "Dernière relance manuelle (ou suite à un DEPA)",
                  columns: [{
                    value: moment(user.shortElearninglastEmailSentDate).format("DD/MM/YYYY")
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }]
                });
              } else if (user.shortElearninglastSmsSentDate) {
                campaignHistoryLines.push({
                  label: "Dernière relance manuelle (ou suite à un DEPA)",
                  columns: [{
                    value: moment(user.shortElearninglastSmsSentDate).format("DD/MM/YYYY")
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }, {
                    value: ""
                  }]
                });
              }
              _iteratorNormalCompletion7 = true;
              _didIteratorError7 = false;
              _iteratorError7 = undefined;
              _context3.prev = 253;
              for (_iterator7 = campaignLinks[Symbol.iterator](); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                _link = _step7.value;

                campaignHistoryLines.push({
                  label: _link.name,
                  color: _link.viewed || _link.progress >= 95 ? "#337ab7" : _link.emailSentDate && !_link.emailErrorcode || _link.smsSentDate ? "#F9A159" : "#ff3108",
                  columns: [{
                    value: _link.emailSentDate && !_link.emailErrorcode ? moment(_link.emailSentDate).add(_link.increment || 0, "days").format("DD/MM/YYYY") + " (par email)" : _link.smsSentDate ? moment(_link.smsSentDate).add(_link.increment || 0, "days").format("DD/MM/YYYY") + " (par SMS)" : moment(_link.startDate).add(_link.increment || 0, "days").format("DD/MM/YYYY") + (_link.emailErrorcode ? " (non délivrée)" : _link.isWithQrCode ? " (QR code)" : _link.viewed || _link.progress >= 95 ? "" : " (non envoyée)")
                  }, {
                    value: _link.viewed || _link.progress >= 95 ? "Oui" : "Non"
                  }, {
                    value: _link.doneDate ? moment(_link.doneDate).format("DD/MM/YYYY") : ""
                  }, {
                    value: _link.total ? _link.score + "/" + _link.total : !_link.viewed ? "" : _link.score !== "Pas de quiz" ? _link.courseId && !_link._id ? "Visualisé lors d'une session de formation" : "Non répondu" : "Sans quiz"
                  }]
                });
              }
              _context3.next = 261;
              break;

            case 257:
              _context3.prev = 257;
              _context3.t17 = _context3["catch"](253);
              _didIteratorError7 = true;
              _iteratorError7 = _context3.t17;

            case 261:
              _context3.prev = 261;
              _context3.prev = 262;

              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }

            case 264:
              _context3.prev = 264;

              if (!_didIteratorError7) {
                _context3.next = 267;
                break;
              }

              throw _iteratorError7;

            case 267:
              return _context3.finish(264);

            case 268:
              return _context3.finish(261);

            case 269:
              if (!(challenges && challenges.length > 0)) {
                _context3.next = 313;
                break;
              }

              _iteratorNormalCompletion8 = true;
              _didIteratorError8 = false;
              _iteratorError8 = undefined;
              _context3.prev = 273;
              _iterator8 = challenges.reverse()[Symbol.iterator]();

            case 275:
              if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                _context3.next = 299;
                break;
              }

              challenge = _step8.value;
              _iteratorNormalCompletion9 = true;
              _didIteratorError9 = false;
              _iteratorError9 = undefined;
              _context3.prev = 280;

              for (_iterator9 = challenge.links.reverse()[Symbol.iterator](); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                _link2 = _step9.value;

                challengeHistoryLines.push({
                  label: "Challenge " + challenge.name + " - Jour " + _link2.challengeDay,
                  color: _link2.viewed || _link2.progress >= 95 ? "#337ab7" : _link2.emailSentDate && !_link2.emailErrorcode || _link2.smsSentDate ? "#F9A159" : "#ff3108",
                  columns: [{
                    value: _link2.emailSentDate && !_link2.emailErrorcode ? moment(_link2.emailSentDate).add(_link2.increment || 0, "days").format("DD/MM/YYYY") + " (par email)" : _link2.smsSentDate ? moment(_link2.smsSentDate).add(_link2.increment || 0, "days").format("DD/MM/YYYY") + " (par SMS)" : moment(_link2.startDate).add(_link2.increment || 0, "days").format("DD/MM/YYYY") + (_link2.emailErrorcode ? " (non délivrée)" : _link2.isWithQrCode ? " (QR code)" : _link2.viewed || _link2.progress >= 95 ? "" : " (non envoyée)")
                  }, {
                    value: _link2.viewed || _link2.progress >= 95 ? "Oui" : "Non"
                  }, {
                    value: _link2.doneDate ? moment(_link2.doneDate).format("DD/MM/YYYY") : ""
                  }, {
                    value: _link2.total ? _link2.score + "/" + _link2.total : !_link2.viewed ? "" : _link2.score !== "Pas de quiz" ? _link2.courseId && !_link2._id ? "Visualisé lors d'une session de formation" : "Non répondu" : "Sans quiz"
                  }]
                });
              }
              _context3.next = 288;
              break;

            case 284:
              _context3.prev = 284;
              _context3.t18 = _context3["catch"](280);
              _didIteratorError9 = true;
              _iteratorError9 = _context3.t18;

            case 288:
              _context3.prev = 288;
              _context3.prev = 289;

              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }

            case 291:
              _context3.prev = 291;

              if (!_didIteratorError9) {
                _context3.next = 294;
                break;
              }

              throw _iteratorError9;

            case 294:
              return _context3.finish(291);

            case 295:
              return _context3.finish(288);

            case 296:
              _iteratorNormalCompletion8 = true;
              _context3.next = 275;
              break;

            case 299:
              _context3.next = 305;
              break;

            case 301:
              _context3.prev = 301;
              _context3.t19 = _context3["catch"](273);
              _didIteratorError8 = true;
              _iteratorError8 = _context3.t19;

            case 305:
              _context3.prev = 305;
              _context3.prev = 306;

              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }

            case 308:
              _context3.prev = 308;

              if (!_didIteratorError8) {
                _context3.next = 311;
                break;
              }

              throw _iteratorError8;

            case 311:
              return _context3.finish(308);

            case 312:
              return _context3.finish(305);

            case 313:

              if (elearningLinks && elearningLinks.length > 0) {
                forms.push({
                  name: doneElearningsNumber + "/" + elearningLinks.length + " e-learning(s) effectu\xE9(s)",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  headers: ["Vidéo", "Date d'envoi", "Visionnée", "Date de visionnage", "Quiz"],
                  isMultiColumns: true,
                  lines: elearningHistoryLines
                });
              }

              if (campaignLinks && campaignLinks.length > 0) {
                forms.push({
                  name: doneVideosNumber + "/" + campaignLinks.length + " vid\xE9o(s) vue(s)",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  headers: ["Vidéo", "Date d'envoi", "Visionnée", "Date de visionnage", "Quiz"],
                  isMultiColumns: true,
                  lines: campaignHistoryLines
                });
              }

              if (challenges && challenges.length > 0) {
                forms.push({
                  name: doneChallengeNumber + "/" + allChallengesNumber + " challenge(s) effectu\xE9(s)",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  headers: ["Vidéo", "Date d'envoi", "Visionnée", "Date de visionnage", "Quiz"],
                  isMultiColumns: true,
                  lines: challengeHistoryLines
                });
              }

              if (courses && courses.length > 0) {
                forms.push({
                  name: courses.length + " formation(s)",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  headers: ["Nom", "Type", "Date"],
                  isMultiColumns: true,
                  lines: courses.map(function (course) {
                    return {
                      label: course.name,
                      columns: [{ value: course.typeName }, {
                        value: course.startDate ? moment(course.startDate).format("DD/MM/YYYY") : ""
                      }]
                    };
                  })
                });
              }

              if (!(damages && damages.length > 0)) {
                _context3.next = 347;
                break;
              }

              damageLines = [];


              if (user.nbMissingDepas > 0) {
                damageLines.push({
                  label: "Nombre de RDV manqués au cours des 12 derniers mois",
                  value: user.nbMissingDepas,
                  isWarning: true
                });
              }
              _iteratorNormalCompletion10 = true;
              _didIteratorError10 = false;
              _iteratorError10 = undefined;
              _context3.prev = 323;
              _loop2 = /*#__PURE__*/regeneratorRuntime.mark(function _loop2() {
                var damage, accidentOrigin, docs, docsBilling;
                return regeneratorRuntime.wrap(function _loop2$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        damage = _step10.value;

                        damageLines.push({
                          label: "Date du sinistre",
                          value: damage.dateDamage ? moment(damage.dateDamage).format("DD/MM/YYYY") : "",
                          titleBefore: "Sinistre n°" + damage.name,
                          titleCentered: true
                        });
                        damageLines.push({
                          label: "Type de sinistre",
                          value: damage.typeOfAccidentName
                        });

                        if (!damage.vehicleId) {
                          _context.next = 12;
                          break;
                        }

                        _context.t0 = damageLines;
                        _context.next = 7;
                        return VehiclesService.getNameById(damage.vehicleId);

                      case 7:
                        _context.t1 = _context.sent;
                        _context.t2 = {
                          label: "Véhicule",
                          value: _context.t1
                        };

                        _context.t0.push.call(_context.t0, _context.t2);

                        _context.next = 13;
                        break;

                      case 12:
                        damageLines.push({
                          label: "Véhicule",
                          value: damage.externalVehicleName
                        });

                      case 13:
                        damageLines.push({
                          label: "Circonstances",
                          value: damage.circumstance
                        });
                        damageLines.push({
                          label: "Resp. présumée",
                          value: damage.depa && damage.depa.status === "Effectué" && damage.depa.answers.responsability ? damage.depa.answers.responsability[0] : damage.pourcentageDispute
                        });
                        damageLines.push({
                          label: "Statut du DEPA",
                          value: damage.depa && damage.depa.status === "Effectué" ? "Effectu\xE9 le " + moment(damage.depa.slot.start).format("DD/MM/YYYY") + " avec " + damage.depa.slot.operatorName : damage.depa && damage.depa.status === "Annulé" ? "Annulé (" + damage.depa.reasonCancelName + ")" : damage.depa && damage.depa.status ? damage.depa.status : ""
                        });
                        if (damage.depa && damage.depa.status === "Effectué") {
                          damageLines.push({
                            label: "Mots-clés",
                            value: damage.depa.answers.keywords.map(function (keyword) {
                              return "#" + keyword;
                            }).join(", ")
                          });
                          damageLines.push({
                            label: "Évitabilité",
                            value: damage.depa.answers.commentSuggestions ? damage.depa.answers.commentSuggestions : damage.depa.answers.commentGlass ? damage.depa.answers.commentGlass : ""
                          });
                          damageLines.push({
                            label: "Évitable pour le conducteur",
                            value: damage.depa.answers.isEvitable === true ? "Oui" : damage.depa.answers.isEvitable === false ? "Non" : ""
                          });
                          if (damage.depa.answers.isEvitable === false) {
                            damageLines.push({
                              label: "Évitable pour LVR",
                              value: damage.depa.answers.isEvitableLvr === true ? "Oui" : damage.depa.answers.isEvitableLvr === false ? "Non" : ""
                            });
                            damageLines.push({
                              label: "Conseils LVR",
                              value: damage.depa.answers.commentAdvices ? damage.depa.answers.commentAdvices : damage.depa.answers.commentNotEvitable ? damage.depa.answers.commentNotEvitable : ""
                            });
                          }
                          damageLines.push({
                            label: "Évaluation de l'entretien",
                            value: damage.depa.answers.interviewEvaluation ? damage.depa.answers.interviewEvaluation[0] + "/5" : "-/5"
                          });
                          if (damage.depa.managerAct && damage.depa.managerAct.actDate) {
                            damageLines.push({
                              label: "Acte managérial",
                              value: "Oui"
                            });
                            if (damage.depa.managerAct.comment) {
                              damageLines.push({
                                label: "Commentaire du manageur",
                                value: damage.depa.managerAct.comment
                              });
                            }
                          } else if (damage.depa.managerAct && !damage.depa.managerAct.actDate) {
                            damageLines.push({
                              label: "Acte managérial",
                              value: "Non"
                            });
                          }
                          if (isLvr) {
                            if (damage.depa && damage.depa.answers && damage.depa.answers.commentOnDriver && damage.depa.answers.commentOnDriver.replace(/\s/g, "").length > 0) {
                              damageLines.push({
                                label: "Commentaire interne LVR",
                                value: damage.depa.answers.commentOnDriver,
                                hiddenIfPrint: true
                              });
                            }

                            if (damage.depa && damage.depa.answers && damage.depa.answers.accidentOrigin && damage.depa.answers.accidentOrigin.length) {
                              accidentOrigin = accidentOriginList.find(function (origin) {
                                return origin.value === damage.depa.answers.accidentOrigin[0];
                              });

                              damageLines.push({
                                label: "Défaillance humaine à l'origine des accidents",
                                value: accidentOrigin.name,
                                hiddenIfPrint: true
                              });
                            }
                          }
                        }
                        if (damage.lal) {
                          damageLines.push({
                            label: "Statut assurance",
                            value: damage.lal.statusInsurer
                          });
                        } else if (damage.insurer && !damage.insurer.noReport) {
                          damageLines.push({
                            label: "Statut assurance",
                            value: "Envoyé"
                          });
                        }
                        if (damage.lal && damage.lal.statusInsurer === "Clos") {
                          damageLines.push({
                            label: "Coût assurance",
                            value: damage.lal.costTotal + " €"
                          });
                          damageLines.push({
                            label: "Resp. assurance",
                            value: damage.lal.pourcentageDispute + " %"
                          });
                        }

                        docs = damage.docs && damage.docs.length > 0 ? damage.docs : [];
                        docsBilling = damage.docsBilling && damage.docsBilling.length > 0 ? damage.docsBilling : [];

                        damageLines.push({
                          label: "Documents du sinistre",
                          value: [].concat(_toConsumableArray(docs.filter(function (doc) {
                            return doc.what && doc.what.value !== "U1" && doc.what.value !== "U1B" && doc.what.value !== "V1" && doc.what.value !== "other";
                          })), _toConsumableArray(docsBilling.filter(function (doc) {
                            return doc.what && doc.what.value !== "other";
                          })))
                        });
                        damageLines.push({
                          label: "Documents du DEPA",
                          value: [].concat(_toConsumableArray(damage.depa.docs && damage.depa.docs.length ? [damage.depa.docs[damage.depa.docs.length - 1]] // Seul le dernier document (le + à jour) est affiché
                          : []), _toConsumableArray(damage.depa.managerAct && damage.depa.managerAct.docs ? damage.depa.managerAct.docs : []))
                        });

                      case 23:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop2, _this);
              });
              _iterator10 = damages[Symbol.iterator]();

            case 326:
              if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                _context3.next = 331;
                break;
              }

              return _context3.delegateYield(_loop2(), "t20", 328);

            case 328:
              _iteratorNormalCompletion10 = true;
              _context3.next = 326;
              break;

            case 331:
              _context3.next = 337;
              break;

            case 333:
              _context3.prev = 333;
              _context3.t21 = _context3["catch"](323);
              _didIteratorError10 = true;
              _iteratorError10 = _context3.t21;

            case 337:
              _context3.prev = 337;
              _context3.prev = 338;

              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }

            case 340:
              _context3.prev = 340;

              if (!_didIteratorError10) {
                _context3.next = 343;
                break;
              }

              throw _iteratorError10;

            case 343:
              return _context3.finish(340);

            case 344:
              return _context3.finish(337);

            case 345:

              forms.push({
                name: damages.length + " sinistre(s) dont " + depasDoneNumber + " DEPA(s) effectu\xE9(s)",
                filters: ["Fiche avec sinistres détaillés"],
                lines: damageLines
              });

              forms.push({
                name: damages.length + " sinistre(s) dont " + depasDoneNumber + " DEPA(s) effectu\xE9(s)" + (user.nbMissingDepas > 0 ? " - " + user.nbMissingDepas + " RDV manqué(s) au cours des 12 derniers mois : " : ""),
                filters: ["Fiche"],
                headers: ["Numéro", "Date du sinistre", "Type de sinistre", "Circonstances", "Resp. présumée", "Statut du DEPA", "Acte managérial"],
                isMultiColumns: true,
                lines: damages.map(function (damage) {
                  return {
                    label: damage.name,
                    columns: [{
                      value: damage.dateDamage ? moment(damage.dateDamage).format("DD/MM/YYYY") : ""
                    }, {
                      value: damage.typeOfAccidentName
                    }, {
                      value: damage.circumstance
                    }, {
                      value: damage.pourcentageDispute
                    }, {
                      value: damage.depa && damage.depa.status ? damage.depa.status : "",
                      link: function () {
                        if (!damage.depa) return null;
                        if ($rootScope.$user.role === "super-admin") {
                          var currentUserGroupIds = $rootScope.$user.groupsId;
                          var view = currentUserGroupIds.some(function (groupId) {
                            return groupId === "$633be6ad8a10010012815d87";
                          }) ? "preventeur" : currentUserGroupIds.some(function (groupId) {
                            return groupId === "$65f2d6bf5075b5001298901a";
                          }) ? "detaillee" : "standard";
                          return DEPA_FORM_URL + "/?id=" + damage.depa._id + "&shortId=" + damage.depa.shortId + "&token=" + token + "&trainingMode=false&view=" + view;
                        }
                        return damage.depa.docs && damage.depa.docs.length > 0 ? damage.depa.docs[damage.depa.docs.length - 1].url : null;
                      }()
                    }, {
                      value: damage.depa && damage.depa.managerAct ? damage.depa.managerAct.actDate ? "Oui" : "Non" : damage.depa && damage.depa.managerActCancelled ? "Annulé" : ""
                    }]
                  };
                })
              });

            case 347:
              if (!(isLvr && damages && damages.length > 0)) {
                _context3.next = 374;
                break;
              }

              lvrComments = [];
              accidentOrigins = [];
              _depas = damages.filter(function (damage) {
                return damage.depa && damage.depa.status === "Effectué";
              });

              if (!(_depas && _depas.length > 0)) {
                _context3.next = 372;
                break;
              }

              _iteratorNormalCompletion11 = true;
              _didIteratorError11 = false;
              _iteratorError11 = undefined;
              _context3.prev = 355;

              _loop3 = function _loop3() {
                var depa = _step11.value;

                if (depa.depa && depa.depa.answers && depa.depa.answers.commentOnDriver && depa.depa.answers.commentOnDriver.replace(/\s/g, "").length > 0) {
                  lvrComments.push({
                    label: "Sinistre n\xB0" + depa.name + " - DEPA du " + moment(depa.depa.slot.start).format("DD/MM/YYYY"),
                    value: depa.depa.answers.commentOnDriver
                  });
                }

                if (depa.depa && depa.depa.answers && depa.depa.answers.accidentOrigin && depa.depa.answers.accidentOrigin.length) {
                  var accidentOrigin = accidentOriginList.find(function (origin) {
                    return origin.value === depa.depa.answers.accidentOrigin[0];
                  });
                  accidentOrigins.push({
                    label: "Sinistre n\xB0" + depa.name + " - DEPA du " + moment(depa.depa.slot.start).format("DD/MM/YYYY"),
                    value: accidentOrigin ? accidentOrigin.name : depa.depa.answers.accidentOrigin[0]
                  });
                }
              };

              for (_iterator11 = _depas[Symbol.iterator](); !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                _loop3();
              }
              _context3.next = 364;
              break;

            case 360:
              _context3.prev = 360;
              _context3.t22 = _context3["catch"](355);
              _didIteratorError11 = true;
              _iteratorError11 = _context3.t22;

            case 364:
              _context3.prev = 364;
              _context3.prev = 365;

              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }

            case 367:
              _context3.prev = 367;

              if (!_didIteratorError11) {
                _context3.next = 370;
                break;
              }

              throw _iteratorError11;

            case 370:
              return _context3.finish(367);

            case 371:
              return _context3.finish(364);

            case 372:

              if (accidentOrigins.length > 0) {
                forms.unshift({
                  name: "Défaillance humaine à l'origine des accidents",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  lines: accidentOrigins,
                  hiddenIfPrint: true
                });
              }
              if (lvrComments.length > 0) {
                forms.unshift({
                  name: "Historique des commentaires LVR",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  lines: lvrComments,
                  hiddenIfPrint: true
                });
              }

            case 374:

              if (isAdmin && user.role && user.role !== "driver") {
                forms.push({
                  name: "Sécurité",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  lines: [{
                    label: "Privilège",
                    value: user.roleName
                  }, {
                    label: "Droits de se connecter à la bêta",
                    value: user.canLoginToBeta || ["super-admin", "super-operator", "operator"].indexOf(user.role) > -1 ? "Oui" : "Non",
                    hidden: !isSuperAdmin
                  }, {
                    label: "Accès aux menus",
                    value: user.rights && user.rights.resource && user.rights.resource.read || ["super-admin", "super-operator", "operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non",
                    titleBefore: "Menus Collaborateurs/Véhicules"
                  }, {
                    label: "Boutons ''Créer/Modifier''",
                    value: user.rights && user.rights.resource && user.rights.resource.write || ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Bouton ''Supprimer''",
                    value: user.rights && user.rights.resource && user.rights.resource.delete || ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Accès au menu",
                    value: user.rights && user.rights.damage && user.rights.damage.read || ["super-admin", "super-operator", "operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non",
                    titleBefore: "Menu Sinistre"
                  }, {
                    label: "Boutons ''Créer/Modifier''",
                    value: user.rights && user.rights.damage && user.rights.damage.write || ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Bouton ''Transmettre''",
                    value: user.rights && user.rights.damage && user.rights.damage.send || ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Bouton ''Supprimer''",
                    value: user.rights && user.rights.damage && user.rights.damage.delete || ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Voir uniquement les litiges marchandises",
                    value: user.onlyMerchandise ? "Oui" : "Non"
                  }, {
                    label: "Accès au menu",
                    value: user.rights && user.rights.depa && user.rights.depa.read || ["super-admin", "super-operator", "operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non",
                    titleBefore: "Menu DEPA"
                  }, {
                    label: "Boutons ''Gérer le RDV''",
                    value: user.rights && user.rights.depa && user.rights.depa.write || ["super-admin", "super-operator", "operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Valider les actes pour ses groupes",
                    value: user.rights && user.rights.managerAct && user.rights.managerAct.validate ? "Oui" : "Non",
                    titleBefore: "Actes managériaux"
                  }, {
                    label: "Accès au menu",
                    value: user.rights && user.rights.course && user.rights.course.read || ["super-admin", "super-operator", "operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non",
                    titleBefore: "Menu Formation"
                  }, {
                    label: "Boutons ''Créer/Modifier''",
                    value: user.rights && user.rights.course && user.rights.course.write || ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Bouton ''Supprimer''",
                    value: user.rights && user.rights.course && user.rights.course.delete || ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? "Oui" : "Non"
                  }, {
                    label: "Ce collaborateur est virtuel (n'existe pas dans le logiciel SIRH/gestion de flotte)",
                    value: user.isVirtual ? "Oui" : "Non",
                    titleBefore: "Autre",
                    hidden: !isSuperAdmin
                  }, {
                    label: "Ce conducteur est visible par tout le monde",
                    value: user.isVisibleByEveryone ? "Oui" : "Non",
                    hidden: !isSuperAdmin
                  }]
                });
              }

              if (isAdmin && user.role === "driver") {
                forms.push({
                  name: "Sécurité",
                  filters: ["Fiche", "Fiche avec sinistres détaillés"],
                  lines: [{
                    label: "Valider les actes pour ses groupes",
                    value: user.rights && user.rights.managerAct && user.rights.managerAct.validate ? "Oui" : "Non",
                    titleBefore: "Actes managériaux"
                  }]
                });
              }

              forms.push({
                name: "Documents",
                filters: ["Documents"],
                lines: [{
                  label: "Documents associés à ses DEPA",
                  value: user.depaDocs.reverse()
                }]
              });

              actionHistoryfrom = moment().subtract(7, "days").startOf("day").toDate();
              actionHistoryTo = moment().endOf("day").toDate();
              where = {
                date: { $gte: actionHistoryfrom, $lte: actionHistoryTo },
                userId: "$" + user._id
              };
              actionHistories = [];

              if (!(isAdmin || isLvr)) {
                _context3.next = 384;
                break;
              }

              _context3.next = 384;
              return ActionHistoriesService.load(null, false, null, where).then(function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(actions) {
                  var _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, actionHistory;

                  return regeneratorRuntime.wrap(function _callee$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _iteratorNormalCompletion12 = true;
                          _didIteratorError12 = false;
                          _iteratorError12 = undefined;
                          _context2.prev = 3;
                          _iterator12 = actions[Symbol.iterator]();

                        case 5:
                          if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                            _context2.next = 15;
                            break;
                          }

                          actionHistory = _step12.value;
                          _context2.next = 9;
                          return _this.getNameById(actionHistory.userId);

                        case 9:
                          actionHistory.userName = _context2.sent;

                          actionHistory.action = actionHistory.action ? actionHistory.action.split("?")[0] : "";

                          actionHistories.push(actionHistory);

                        case 12:
                          _iteratorNormalCompletion12 = true;
                          _context2.next = 5;
                          break;

                        case 15:
                          _context2.next = 21;
                          break;

                        case 17:
                          _context2.prev = 17;
                          _context2.t0 = _context2["catch"](3);
                          _didIteratorError12 = true;
                          _iteratorError12 = _context2.t0;

                        case 21:
                          _context2.prev = 21;
                          _context2.prev = 22;

                          if (!_iteratorNormalCompletion12 && _iterator12.return) {
                            _iterator12.return();
                          }

                        case 24:
                          _context2.prev = 24;

                          if (!_didIteratorError12) {
                            _context2.next = 27;
                            break;
                          }

                          throw _iteratorError12;

                        case 27:
                          return _context2.finish(24);

                        case 28:
                          return _context2.finish(21);

                        case 29:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee, _this, [[3, 17, 21, 29], [22,, 24, 28]]);
                }));

                return function (_x8) {
                  return _ref4.apply(this, arguments);
                };
              }()).catch(function (err) {
                console.error("err", err);
              });

            case 384:
              _context3.next = 386;
              return this.getHistory(user._id);

            case 386:
              user.history = _context3.sent;


              ModalService.openComponent("custom-iframe", {
                source: source,
                title: "Fiche récapitulative",
                size: "lg",
                keyboard: false,
                heightCalculationMethod: "bodyOffset",
                closeEvent: "mutationObserver",
                message: {
                  emails: emails,
                  actionHistories: actionHistories,
                  object: user,
                  customerName: user.customerName,
                  titleName: "Collaborateur " + user.lastName + " " + user.firstName,
                  headerName: "Fiche récapitulative Collaborateur",
                  footerName: "Collaborateur " + user.lastName + " " + user.firstName,
                  fileName: "Fiche r\xE9cap - " + user.lastName + " " + user.firstName + ".pdf",
                  filters: damages && damages.length ? ["Fiche", "Fiche avec sinistres détaillés", "Documents"] : ["Fiche", "Documents"],
                  forms: forms,
                  allowQrCodeToggle: true,
                  qrCodeUrl: appShortUrl,
                  qrCodeName: appShortUrl.includes("/s/") ? "Lien vers l'espace perso :" : "Lien vers l'application :",
                  videos: damages ? damages.map(function (damage) {
                    var docs = damage.docs ? damage.docs : [];
                    docs = damage.docsBilling ? [].concat(_toConsumableArray(docs), _toConsumableArray(damage.docsBilling)) : docs;
                    return docs.filter(function (doc) {
                      return doc.url.match(/\.(mp4|webm|ogg)(\?.*)?$/i);
                    }).map(function (doc) {
                      doc.name = "Sinistre n°" + damage.name + " - " + doc.name;
                      return doc;
                    });
                  }).flat() : []
                }
              }).then(function () {
                console.log("close modal");
              }).catch(function (err) {
                console.error("err", err);
              });

            case 388:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2, this, [[20, 27], [77, 82, 86, 94], [87,, 89, 93], [97, 102, 106, 114], [107,, 109, 113], [117, 129, 133, 141], [134,, 136, 140], [144, 148, 152, 160], [153,, 155, 159], [169, 174, 178, 186], [179,, 181, 185], [232, 236, 240, 248], [241,, 243, 247], [253, 257, 261, 269], [262,, 264, 268], [273, 301, 305, 313], [280, 284, 288, 296], [289,, 291, 295], [306,, 308, 312], [323, 333, 337, 345], [338,, 340, 344], [355, 360, 364, 372], [365,, 367, 371]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  that.getName = function (o) {
    if (o) {
      if (o.error === 404 && !["super-admin", "super-operator", "operator", "user-admin", "hr"].includes($rootScope.$user.role)) {
        return "Masqué (hors périmètre)";
      } else if (o.error === 404) {
        return "Supprimé";
      }

      var name = "";

      if (o.lastName) {
        name = name + o.lastName.toUpperCase() + " ";
      }

      if (o.firstName) {
        name = name + o.firstName.charAt(0).toUpperCase() + o.firstName.slice(1).toLowerCase() + " ";
      }

      if (name.length == 0 && o.internalNumber) {
        name = o.internalNumber;
      }

      // DHL case
      if (name.length == 0 && o.email) {
        name = o.email;
      }

      if (name.length == 0) {
        name = "N.C.";
      }

      var active = !o.endDate || new Date(o.endDate) >= new Date() ? true : false;
      if (!active) {
        name = "Sorti de l'entreprise : " + name;
      }

      return name;
    } else {
      return "N.C.";
    }
  };

  that.getLvrTrainerArray = function () {
    return new Promise(function (resolve, reject) {
      that.customGet("trainers/" + $rootScope.$selectedCustomerId + "?lvr=true").then(function (trainers) {
        var array = [];

        for (var index = 0; index < trainers.length; index++) {
          var trainer = trainers[index];

          array.push({
            name: that.getName(trainer) + " (LVR) ",
            value: "$" + trainer._id
          });
        }
        resolve(array);
      });
    });
  };

  that.getCustomerTrainerArray = function () {
    return new Promise(function (resolve, reject) {
      that.customGet("trainers/" + $rootScope.$selectedCustomerId).then(function (trainers) {
        var array = [];

        for (var index = 0; index < trainers.length; index++) {
          var trainer = trainers[index];

          array.push({
            name: that.getName(trainer),
            value: "$" + trainer._id
          });
        }
        resolve(array);
      });
    });
  };

  that.getArray = function (condition, pattern) {
    return new Promise(function (resolve, reject) {
      console.log("getArray", condition, pattern);

      var where = {};

      if (condition) {
        where = condition ? condition : {};
      }

      if (pattern) {
        where.or = [{ lastName: { like: pattern, options: "i" } }, { firstName: { like: pattern, options: "i" } }];
      }

      that.load(["lastName", // lastName en 1er car ça permet de trier par nom de famille
      "firstName", "internalNumber", "_id", "email", "cellularPhone", "phone", "defaultManagerId", "rhManagerId", "qseManagerId", "fleetManagerId", "other1ManagerId", "other2ManagerId", "contract", "yearOfBirth", "startDate", "endDate", "positions"], true, null, where).then(function (values) {
        var array = [];

        for (var index = 0; index < values.length; index++) {
          var response = values[index];

          var active = !response.endDate || new Date(response.endDate) >= new Date() ? true : false;

          array.push({
            name: String(that.getName(response)) + (!active ? " <sorti(e) de l'entreprise>" : "") + (response.internalNumber ? " (n\xB0" + response.internalNumber + ")" : "") + (response.positions ? " [" + response.positions + "]" : ""),
            value: "$" + response._id
          });
        }

        array = array.sort(function (a, b) {
          if (a.name) {
            if (a.name.includes("<sorti(e) de l'entreprise>")) {
              return 1;
            }
            if (b.name.includes("<sorti(e) de l'entreprise>")) {
              return -1;
            }

            if (b.name) {
              return a.name.localeCompare(b.name);
            } else {
              return 1;
            }
          } else {
            return -1;
          }
        });

        resolve(array);
      });
    });
  };

  that.getArrayByPosition = function (position, pattern) {
    return that.getArray({ positions: position }, pattern);
  };

  that.getArrayByRole = function (role, pattern) {
    return that.getArray({ role: role }, pattern);
  };

  that.getPositionArray = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(customerId) {
      var displayAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var array;
      return regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              array = void 0;

              if (!(customerId === "$592e962acef2545fb62f1a99")) {
                _context4.next = 7;
                break;
              }

              _context4.next = 4;
              return CustomListsService.getSelectArray("typePositionLvr");

            case 4:
              array = _context4.sent;
              _context4.next = 10;
              break;

            case 7:
              _context4.next = 9;
              return CustomListsService.getSelectArray("typePosition");

            case 9:
              array = _context4.sent;

            case 10:
              array = array.filter(function (item) {
                if (item.value === $rootScope.rhManagerValue && $rootScope.rhManagerHidden) {
                  return false;
                } else if (item.value === $rootScope.qseManagerValue && $rootScope.qseManagerHidden) {
                  return false;
                } else if (item.value === $rootScope.fleetManagerValue && $rootScope.fleetManagerHidden) {
                  return false;
                } else if (item.value === $rootScope.other1ManagerValue && $rootScope.other1ManagerHidden) {
                  return false;
                } else if (item.value === $rootScope.other2ManagerValue && $rootScope.other2ManagerHidden) {
                  return false;
                } else {
                  return true;
                }
              }).map(function (item) {
                if (item.value === $rootScope.defaultManagerValue) {
                  item.name = $rootScope.defaultManagerLabel;
                } else if (item.value === $rootScope.rhManagerValue) {
                  item.name = $rootScope.rhManagerLabel;
                } else if (item.value === $rootScope.qseManagerValue) {
                  item.name = $rootScope.qseManagerLabel;
                } else if (item.value === $rootScope.fleetManagerValue) {
                  item.name = $rootScope.fleetManagerLabel;
                } else if (item.value === $rootScope.other1ManagerValue) {
                  item.name = $rootScope.other1ManagerLabel;
                } else if (item.value === $rootScope.other2ManagerValue) {
                  item.name = $rootScope.other2ManagerLabel;
                }
                return item;
              });
              return _context4.abrupt("return", array);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function (_x9) {
      return _ref5.apply(this, arguments);
    };
  }();

  that.login = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(credential) {
      var response;
      return regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return that.post("auth/login", credential);

            case 2:
              response = _context5.sent;

              if (response.id) {
                _context5.next = 5;
                break;
              }

              throw response;

            case 5:
              ApiService.setToken(response.id); // In-memory for cross-app URLs; auth cookie set by server
              return _context5.abrupt("return", response);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4, _this2);
    }));

    return function (_x11) {
      return _ref6.apply(this, arguments);
    };
  }();

  that.logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return that.post("auth/logout");

          case 2:
            response = _context6.sent;

            ApiService.setToken(null);
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5, _this2);
  }));

  that.remoteSelectArray = function (positions) {
    var _this3 = this;

    console.log("call remoteSelectArray user for " + $rootScope.$selectedCustomerId);

    return new Promise(function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve, reject) {
        var remote, list;
        return regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return that.customPost("selectArray", {
                  customerId: $rootScope.$selectedCustomerId,
                  positions: positions
                });

              case 2:
                remote = _context7.sent;


                if (remote.success == true) {
                  list = remote.data.map(function (user) {
                    user.positions = user.positions && user.positions.length ? user.positions.filter(function (item) {
                      if (item === $rootScope.rhManagerValue && $rootScope.rhManagerHidden) {
                        return false;
                      } else if (item === $rootScope.qseManagerValue && $rootScope.qseManagerHidden) {
                        return false;
                      } else if (item === $rootScope.fleetManagerValue && $rootScope.fleetManagerHidden) {
                        return false;
                      } else if (item === $rootScope.other1ManagerValue && $rootScope.other1ManagerHidden) {
                        return false;
                      } else if (item === $rootScope.other2ManagerValue && $rootScope.other2ManagerHidden) {
                        return false;
                      } else {
                        return true;
                      }
                    }).map(function (item) {
                      if (item === $rootScope.defaultManagerValue) {
                        item = $rootScope.defaultManagerLabel;
                      } else if (item === $rootScope.rhManagerValue) {
                        item = $rootScope.rhManagerLabel;
                      } else if (item === $rootScope.qseManagerValue) {
                        item = $rootScope.qseManagerLabel;
                      } else if (item === $rootScope.fleetManagerValue) {
                        item = $rootScope.fleetManagerLabel;
                      } else if (item === $rootScope.other1ManagerValue) {
                        item = $rootScope.other1ManagerLabel;
                      } else if (item === $rootScope.other2ManagerValue) {
                        item = $rootScope.other2ManagerLabel;
                      }
                      return item;
                    }) : [];
                    var active = !user.endDate || new Date(user.endDate) >= new Date() ? true : false;
                    return {
                      name: String(that.getName(user)) + (!active ? " <sorti(e) de l'entreprise>" : "") + (user.internalNumber ? " (n\xB0" + user.internalNumber + ")" : "") + (user.positions && user.positions.length ? " [" + user.positions + "]" : ""),
                      value: "$" + user._id
                    };
                  }).sort(function (a, b) {
                    if (a.name) {
                      if (a.name.includes("<sorti(e) de l'entreprise>")) {
                        return 1;
                      }
                      if (b.name.includes("<sorti(e) de l'entreprise>")) {
                        return -1;
                      }

                      if (b.name) {
                        return a.name.localeCompare(b.name);
                      } else {
                        return 1;
                      }
                    } else {
                      return -1;
                    }
                  });


                  list.unshift({ name: "A PRECISER OU NON TROUVE", value: null });
                  resolve(list);
                } else {
                  reject(remote.error);
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, _this3);
      }));

      return function (_x12, _x13) {
        return _ref8.apply(this, arguments);
      };
    }());
  };
}]);